export const dictValues = (state) => state.nomination.dictValues
export const dictNomination = (state) => state.nomination.dictNomination
export const dictParams = (state) => state.nomination.dictParams

export const emplXml = (state) => state.nomination.emplXml
export const emplList = (state) => state.nomination.emplList

export const mioUserCheck = (state) => state.nomination.mioUserCheck
export const mioById = (state) => state.nomination.mioById
export const mioList = (state) => state.nomination.mioList
export const mioCheckRow = (state) => state.nomination.mioCheckRow
export const mioXml = (state) => state.nomination.mioXml
export const mioReport = (state) => state.nomination.mioReport

export const dtspMioList = (state) => state.nomination.dtspMioList
export const dtspReportList = (state) => state.nomination.dtspReportList
export const dtspReportXml = (state) => state.nomination.dtspReportXml
export const dtspReqsList = (state) => state.nomination.dtspReqsList
export const dtspReqsOne = (state) => state.nomination.dtspReqsOne
export const dtspReqsPage = (state) => state.nomination.dtspReqsPage
